"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Tab_1 = __importDefault(require("semantic-ui-react/dist/commonjs/modules/Tab/Tab"));
var Pane_1 = __importDefault(require("./Pane/Pane"));
var Badge_1 = __importDefault(require("../Badge/Badge"));
var MenuItem_1 = __importDefault(require("semantic-ui-react/dist/commonjs/collections/Menu/MenuItem"));
/**
 * A Tab component is a collection of content sections that only displays one of these sections at a time. The Pane component is used to contains the individual children sections.
 * @child ./Pane/Pane.tsx
 */
var Tab = /** @class */ (function (_super) {
    __extends(Tab, _super);
    function Tab() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onTabChangeWrapper = function (event, data) {
            return _this.props.onTabChange && _this.props.onTabChange(data.activeIndex);
        };
        return _this;
    }
    Tab.prototype.render = function () {
        var tabPanes = this.props.children;
        var panes = this.tagsToObjects(tabPanes);
        // splitting the properties
        var _a = this.props, defaultActiveIndex = _a.defaultActiveIndex, className = _a.className, rest = __rest(_a, ["defaultActiveIndex", "className"]);
        if (defaultActiveIndex !== undefined && (defaultActiveIndex >= panes.length || defaultActiveIndex < 0)) {
            defaultActiveIndex = 0;
        }
        return (React.createElement(Tab_1.default, __assign({}, rest, { menu: { secondary: true, pointing: true, className: this.genClasses() }, panes: panes, defaultActiveIndex: defaultActiveIndex, onTabChange: this.onTabChangeWrapper })));
    };
    Tab.prototype.tagsToObjects = function (tabPanes) {
        return React.Children.map(tabPanes, function (tabPane) {
            if (typeof tabPane !== 'object' || tabPane.type !== Pane_1.default) {
                throw new Error('Components inside <Tab> should only be <Tab.Pane>');
            }
            if (tabPane.props.title === undefined) {
                throw new Error('title property is required for <Tab.Pane> component');
            }
            var wrapper = tabPane.props.className ? (React.createElement("div", { className: tabPane.props.className }, tabPane.props.children)) : tabPane.props.children;
            var _a = tabPane.props, title = _a.title, _b = _a.disabled, disabled = _b === void 0 ? false : _b, badgeColor = _a.badgeColor, badge = _a.badge;
            var newBadgeContent = (badge === true) ? undefined : badge;
            if (newBadgeContent) {
                return { menuItem: (React.createElement(MenuItem_1.default, { key: title, disabled: disabled },
                        " ",
                        title,
                        " ",
                        React.createElement(Badge_1.default, { className: 'inTab', color: badgeColor }, newBadgeContent))), render: function () { return wrapper; } };
            }
            else {
                return { menuItem: (React.createElement(MenuItem_1.default, { key: title, disabled: disabled },
                        " ",
                        title,
                        " ")), render: function () { return wrapper; } };
            }
        });
    };
    Tab.prototype.genClasses = function () {
        var className = this.props.className;
        var newClassName = 'ui scuf-tab';
        if (className) {
            newClassName += " " + className;
        }
        return newClassName;
    };
    Tab.Pane = Pane_1.default;
    return Tab;
}(React.Component));
exports.default = Tab;
